<template>
	<div>
		<fade-transition>
			<!-- has not closure-questions yet -->
			<!-- alert, no cq -->
			<div v-if="questions.length==0" key="no-cqs">
				<b-alert show variant="warning" class="text-center">
					<span>
						<font-awesome-icon
							:icon="['fas', 'exclamation']"
							title="click to add new Region to the Template"
							fixed-width
						/>&nbsp;There is no Closure Question assignet to this template.
					</span>
				</b-alert>
			</div>

			<!-- list of closure questions assigned to the template -->
			<b-list-group v-else key="cqs-view" flush>
				<draggable :list="questions" handle=".ddMoveQIcon" @end="questionPositionMoved()">
					<cqItem v-for="(cq) in questions" :cq="cq" :key="cq.id">
						<!-- slot for draggable button -->
						<template v-slot:lead>
							<font-awesome-icon
								title="drag & drop to move the question"
								icon="align-justify"
								class="ddMoveQIcon mr-2"
								fixed-width
							/>
						</template>

						<!-- slot for action button -->
						<template v-slot:button>
							<b-button @click="deAssignMe(cq)" size="sm" variant="danger">
								<font-awesome-icon :icon="['fas', 'minus']" fixed-width />&nbsp;remove
							</b-button>
						</template>
					</cqItem>
				</draggable>
			</b-list-group>
		</fade-transition>
	</div>
</template>
<script>
	import draggable from "vuedraggable";
	import cqItem from "@/components/closureQuestion/closureQuestionListItem.vue";
	import FadeTransition from "@/components/utils/FadeTransition.vue";

	export default {
		name: "closureQuestionAssignetToTemplate_component",

		components: { cqItem, FadeTransition, draggable },

		props: {
			questions: {
				type: Array,
				default: function() {
					return [];
				}
			}
		},

		methods: {
			// the QUESTION changed the position, update item.position = index
			questionPositionMoved() {
				this.questions.map(function(item, index) {
					item.pivot.position = index + 1;
				});

				this.$emit("closureQuestionsOrderChanged", this.questions);
			},

			deAssignMe(cq) {
				this.$emit("deassign", cq);
			}
		}
	};
</script>
<style>
</style>